export default function searchPage() {
  const cardsContainer = document.querySelector('.product-search_results_cards');

  if (!cardsContainer) {
    return;
  }

  const offsetIncrement = 10;
  let offset = offsetIncrement;
  const loadMore = async (event) => {
    event.preventDefault();
    const buttonContainer = cardsContainer.querySelector('.product-search_load');
    const searchParams = JSON.parse(
      typeof buttonContainer.dataset.params !== 'undefined'
        ? buttonContainer.dataset.params
        : '{}'
    );
    const button = buttonContainer.querySelector('button');
    button.innerHTML = 'Loading more';
    const formData = new FormData();
    formData.append('CSRF_TOKEN', window.csrfToken);
    formData.append('action', 'wil/search/fetch');
    formData.append('offset', offset);

    for (const key in searchParams) {
      if (searchParams[key] === null) {
        formData.append(key, '');
      } else if (typeof searchParams[key] === 'object') {
        // specifically, array
        searchParams[key].forEach((value) => {
          formData.append(`${key}[]`, value);
        });
      } else {
        formData.append(key, searchParams[key]);
      }
    }

    try {
      const response = await fetch('', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: formData,
      });

      if (response.ok) {
        const responseJson = await response.json();
        buttonContainer.remove();
        cardsContainer.insertAdjacentHTML('beforeend', responseJson.html);
        offset += offsetIncrement;
        initLoadMore();
      } else {
        console.log(response);
        button.innerHTML = 'Load more';
      }
    } catch (error) {
      console.log(error);
      button.innerHTML = 'Load more';
    }
  }
  const initLoadMore = () => {
    const button = cardsContainer.querySelector('.product-search_load > button');
    
    if (button) {
      button.addEventListener('click', loadMore);
    }
  }

  initLoadMore();
}



// WEBPACK FOOTER //
// ./source/scripts/products/actions/searchPage.js